// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#393D49","menuText":"#bfcbd9","menuActiveText":"#009688"};